import { useEffect, useState } from 'react';
import axios from 'axios';

let cached = null;
let pending = null;
// Monetisation flags from the backend (free beta banner, Stripe test-mode availability).
export const usePaymentsConfig = () => {
  const [cfg, setCfg] = useState(cached);
  useEffect(() => {
    if (cached) return;
    if (!pending) pending = axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/payments/config`).then((r) => { cached = r.data; return cached; }).catch(() => ({ payments_enabled: true }));
    pending.then(setCfg);
  }, []);
  return cfg || { payments_enabled: true, free_beta_until: null, test_payments_allowed: false, loading: true };
};

export const formatBetaDate = (iso) => (iso ? new Date(iso).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '31/12/2027');
